import { render, staticRenderFns } from "./TopicTrends.vue?vue&type=template&id=74c2ba49&scoped=true"
import script from "./TopicTrends.vue?vue&type=script&lang=js"
export * from "./TopicTrends.vue?vue&type=script&lang=js"
import style0 from "./TopicTrends.vue?vue&type=style&index=0&id=74c2ba49&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c2ba49",
  null
  
)

export default component.exports